import { api } from '../utils/api';
import type { DashboardSummary } from '../types/@types/dashboard';

export async function getDashboardSummary(): Promise<DashboardSummary> {
  const { data } = await api.get<DashboardSummary>('/dashboard/summary');
  return data;
}
